// Core
import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import css from './styles.scss'
import globalCss from '../../../scss/global.scss'
import { connect } from 'react-redux'
import { setAuthStatus, unauthenticate, storeUser, setShowCaveonIdModal } from '../../actions/actions'

class Header extends Component {
  constructor (props) {
    super(props)
    this.state = {
      name: null
    }
  }

  fetchUser () {
    fetch('/api/v1/users/me', {
      method: 'GET',
      headers: {
        authorization: `Bearer ${this.props.auth.bearerToken}`
      }
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      } else {
        this.props.dispatch(setAuthStatus('unauthenticated'))
        return { _error: res.statusText }
      }
    }).then(user => {
      if (user.name) {
        this.props.dispatch(storeUser(user))
      } else {
        console.error('ERROR', user)
      }
    })
  }

  componentDidUpdate (prevProps) {
    if (!this.props.user.name && prevProps.auth.authStatus !== 'authenticated' && this.props.auth.authStatus === 'authenticated') {
      this.fetchUser()
    }
  }

  handleLogout = () => {
    window.localStorage.removeItem('smartitems_api_bearer_token')
    window.localStorage.removeItem('smartitems_api_login_code')
    this.props.dispatch(unauthenticate())
    this.props.dispatch(setAuthStatus('unauthenticated'))
    window.location.href = `${process.env.CAVEON_ID_BASE_URL}/logout`
  }

  openCaveonIdModal = () => {
    this.props.dispatch(setShowCaveonIdModal(true))
  }

  render () {
    if (!this.props.auth.authenticated) {
      return null
    }
    const username = this.props.user.name
    let userDisplay = null
    if (username) {
      userDisplay = (
        <li className={css.user}>
          <a onClick={ this.openCaveonIdModal } style={{ cursor: 'pointer' }}><i className={globalCss.iconUser} /> <span className={css.name}>{username}</span></a>
        </li>
      )
    }
    return (
      <header className={`${css.Header} ${this.props.location.pathname !== '/' ? css.innerPage : ''}`}>
        <Link to='/'><img src='/images/logo.png' alt='Caveon SmartItem.' className={css.logo} /></Link>
        <nav className={css.nav}>
          <ul>
            <li><Link to='/items'>Items</Link></li>
            <li><Link to='/access'>Access Tokens</Link></li>
            <li><Link to='/data'>Data Sources</Link></li>
            {userDisplay}
          </ul>
        </nav>
      </header>
    )
  }
}

const mapStateToProps = state => {
  const { auth, user } = state
  return {
    auth,
    user
  }
}

export default withRouter(connect(mapStateToProps)(Header))



// WEBPACK FOOTER //
// /app/js/components/Header/index.js